<template>
  <div id="zoovu-assistant" :class="{ 'pb-8': visible }">
    <NuxtLink v-if="visible" to="/kaufberater/laptop" :external="true">
      <NuxtImg width="945px" height="200px"
        src="53/67/1c/13201d4e5e68e607e29b4a00a5144dafdb/WindowsLaptop_2024_Kategoriebanner_945x200.jpg"
        alt="Banner für Notebook-Berater" />
    </NuxtLink>
  </div>
</template>
<script setup lang="ts">
import type { NeoArticleCategoryView } from '@expert/types';

const props = defineProps<{
  currentCategory: NeoArticleCategoryView | undefined;
}>();

const visible = ref(false);
if (props?.currentCategory?.categoryId == 'e_119' || props?.currentCategory?.categoryId == 'e_118') {
  visible.value = true;
}
</script>
